import React, { useState } from "react";
import { RefetchProvider } from "@piiqtechnologies/ui-lib";
import { PeekGrid, PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
import { Outlet } from "react-router-dom";
import AppHeader from "@components/app-header";
import { Heart } from "@piiqtechnologies/svg-icons";
export const AccountHealthLayout = () => {
    const [layoutConfig, setLayoutConfig] = useState({
        pageTitle: "",
        backButton: false,
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(PeekGrid, { item: true, xs: 12, display: "flex", justifyContent: "space-between" },
            React.createElement(PeekStack, { direction: "row", spacing: 4, alignItems: "center" },
                React.createElement(AppHeader, { headerLabel: layoutConfig === null || layoutConfig === void 0 ? void 0 : layoutConfig.pageTitle, icon: React.createElement(PeekTypography, { variant: "h1", display: "flex", color: "red.400" },
                        React.createElement(Heart, null)) }))),
        React.createElement(PeekGrid, { item: true, xs: 12 },
            React.createElement(RefetchProvider, null,
                React.createElement(Outlet, { context: { setLayoutConfig } })))));
};
